sn-advantages {
  .sn-advantages {
    // me-section padding-bottom override per breakpoint
    .me-container {
      padding-bottom: px-to-rem(43px);

      @include above(768px) {
        padding-bottom: px-to-rem(108px);
      }

      @include above(960px) {
        padding-bottom: px-to-rem(62px);
      }

      @include above(1200px) {
        padding-bottom: px-to-rem(72px);
      }
    }
  }

  // Label slot (title-illustration "Benefits")
  me-tagline {
    display: block;
    color: var(--text-color-primary);
    margin-bottom: px-to-rem(12px);
    text-align: center;
    text-transform: uppercase;

    @include above(960px) {
      text-align: left;
    }
  }

  .sn-advantages__wrap {
    @include above(960px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  // Primary column: heading + image
  .sn-advantages__primary {
    margin-bottom: px-to-rem(42px);

    @include above(768px) {
      display: flex;
      flex-direction: row;
      margin-bottom: px-to-rem(8px);
      align-items: center;
    }

    @include above(960px) {
      display: block;
      margin-right: px-to-rem(40px);
      margin-bottom: 0;
    }

    // Heading styles (section-subtitle)
    me-heading {
      display: block;

      .me-heading {
        max-width: px-to-rem(344px);
        margin: 0 auto px-to-rem(25px);
        font-size: px-to-rem(28px);
        line-height: px-to-rem(36px);
        text-align: center;
        -webkit-font-smoothing: antialiased;
        font-weight: 700;

        @include above(480px) {
          margin-bottom: px-to-rem(40px);
        }

        @include above(768px) {
          max-width: px-to-rem(607px);
          margin-bottom: px-to-rem(35px);
        }

        @include above(960px) {
          width: px-to-rem(362px);
          margin-bottom: px-to-rem(48px);
          margin-left: 0;
          line-height: px-to-rem(40px);
          text-align: left;
        }

        @include above(1200px) {
          min-width: px-to-rem(570px);
          font-size: px-to-rem(48px);
          line-height: px-to-rem(60px);
        }
      }
    }

    // Illustration (me-picture or img)
    me-picture,
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: px-to-rem(250px);
      height: px-to-rem(149px);

      @include above(768px) {
        margin-top: px-to-rem(-22px);
        width: px-to-rem(288px);
        height: px-to-rem(172px);
      }

      @include above(960px) {
        margin-top: 0;
        margin-left: 0;
      }

      @include above(1200px) {
        width: px-to-rem(387px);
        height: px-to-rem(231px);
      }
    }
  }

  // Secondary column: intro + checklist
  .sn-advantages__secondary {
    // Intro text (list-check-title)
    me-text {
      display: block;
      margin-bottom: px-to-rem(18px);

      .me-text {
        font-size: px-to-rem(14px);
        line-height: px-to-rem(24px);
      }

      @include above(960px) {
        margin-top: px-to-rem(10px);
        margin-bottom: px-to-rem(24px);
        padding-left: px-to-rem(34px);
      }

      @include above(1200px) {
        margin-bottom: px-to-rem(34px);
      }
    }
  }

  // Checklist
  .sn-advantages__list {
    list-style: none;
    padding: 0;
    margin: 0;

    @include above(768px) {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
    }
  }

  .sn-advantages__item {
    position: relative;
    padding: 0 0 px-to-rem(24px) px-to-rem(35px);
    font-size: px-to-rem(16px);
    line-height: px-to-rem(24px);
    font-weight: 400;
    overflow: hidden;

    @include above(768px) {
      margin-right: px-to-rem(4px);
      width: calc(50% - #{px-to-rem(22px)});
      padding: 0 0 px-to-rem(35px) px-to-rem(32px);
    }

    // Blue circle with white checkmark
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: px-to-rem(16px);
      height: px-to-rem(16px);
      background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiMzNjdGRjYiLz4KPHBhdGggZD0iTTQuODM4ODcgOC4zMDIxMkw2Ljc2NTA5IDEwLjIyODNMNi43NTI2NCAxMC4yMTU5TDExLjA5ODQgNS44NzAxMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K");
      background-repeat: no-repeat;
      background-size: contain;

      @include above(768px) {
        top: px-to-rem(4px);
      }
    }

    p {
      margin-block-end: 0;
      font-size: px-to-rem(16px);
      line-height: px-to-rem(20px);
    }
  }

  .sn-advantages__item-title {
    margin-bottom: px-to-rem(4px);
    font-size: px-to-rem(16px);
    font-weight: 700;
    line-height: px-to-rem(20px);
  }
}
